import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TextMaskModule } from 'angular2-text-mask';

import { UiCopyButtonModule } from '@unico-people/shared/dashboard/ui-copy-button';

import { InfosAddColabReadComponent } from './read/infos-add-colab.component';
import { InfosAddColabUpdateComponent } from './update/infos-add-colab.component';

@NgModule({
  exports: [InfosAddColabReadComponent, InfosAddColabUpdateComponent],
  declarations: [InfosAddColabReadComponent, InfosAddColabUpdateComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, UiCopyButtonModule, TextMaskModule]
})
export class InfosAddColabModule {}
